// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".WIND0oSVuyMR0g8Jy2GD{max-height:300px;overflow-x:hidden;overflow-y:scroll}html[dir] .WIND0oSVuyMR0g8Jy2GD{padding:3px 0;background:var(--white)}.kjTsxilSx3U7CiJlZMB7{width:65px}html[dir] .pdHRSH_cnOIoB22_vCma{background:var(--neutralLight)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontPickerContainer": "WIND0oSVuyMR0g8Jy2GD",
	"fontSizePicker": "kjTsxilSx3U7CiJlZMB7",
	"comboBoxOptionHovered": "pdHRSH_cnOIoB22_vCma"
};
module.exports = ___CSS_LOADER_EXPORT___;
